export const CONCIERGE_MODE_COOKIE_NAME = 'concierge_mode'

export function setConciergeModeCookie(value: boolean) {
  const expiryDate = new Date()
  expiryDate.setFullYear(expiryDate.getFullYear() + 1)
  document.cookie = `${CONCIERGE_MODE_COOKIE_NAME}=${(value ? 'on' : 'off')}; expires=${expiryDate.toUTCString()}; path=/;`
}
